export enum DateFilterOptions  {
    requestCreationDate = 'Request Creation Date',
    requestStartDate = 'Request Start Date',
    requestEndDate = 'Request End Date'
}

export enum Status {
    published = 'published',
    draft = 'draft'
}

export enum StatusTitle {
    published = 'Published',
    draft = 'Draft'
}

export enum ContentType {
    test = 'test',
    questions = 'questions',
    studyMaterial = 'studyMaterial',
    practiceSet = 'practiceSet'
}

export enum ContentTypeTitle {
    test = 'Test',
    questions = 'Question',
    // studyMaterial = 'Study Material'
}

export enum Priority {
   importantAndUrgent = 'IMPORTANT_AND_URGENT',
   notImportantButUrgent = 'NOT_IMPORTANT_BUT_URGENT',
   importantButNotUrgent = 'IMPORTANT_BUT_NOT_URGENT',
   notImportantAndNotUrgent = 'NOT_IMPORTANT_AND_NOT_URGENT'
}

export enum PriorityTitle {
    importantAndUrgent = 'Important and urgent',
    notImportantButUrgent = 'Not Important but urgent',
    importantButNotUrgent = 'Important but not urgent',
    notImportantAndNotUrgent = 'Not important and not urgent'
}

export enum PriorityBackendKeys {
    importantAndUrgent = 'importantAndUrgent',
    notImportantButUrgent = 'notImportantButUrgent',
    importantButNotUrgent = 'importantButNotUrgent',
    notImportantAndNotUrgent = 'notImportantAndNotUrgent'
}

export enum apiToHit {
    centreHead = 'centreHead',
    multiCentreHead = 'multiCentreHead',
    contentAuthors = 'contentAuthors'
}

export enum Tabs  {
    SentRequest = 'sent',
    ReceivedRequest = 'received'
}

export enum ContentEvaluation {
    contentEvaluation = 'Question',
    testEvaluation = 'Test'
}

export enum ContentRequestStatus {
    notYetStarted = 'Not Yet Started',
    inProgress = 'In Progress',
    done = 'Done'
}

export enum RoleTypes {
    creator = 'creator',
    evaluator = 'evaluator',
    langEvaluator = 'langEvaluator',
    moderator = 'moderator',
    publisher = 'publisher'
}
// priority
export enum  PriorityColors{
    importantUrgent= "red",
    notImportantButUrgent="darkYellow",
    importantNotUrgent="yellow",
    notImportantNotUrgent="green"
}